import React, { FC } from 'react';
import { css, Global } from '@emotion/core';
import { withTheme } from 'emotion-theming';

import fontFace from './fontFace';
import routeTransition from './routeTransition';
import tachyons from './lib/tachyons';
import { AppTheme } from './theme';

const GlobalBaseStyles: FC<{ theme: AppTheme }> = ({ theme }) => (
  <Global
    styles={css`
      /* TACHYONS v4.9.1 | http://tachyons.io */
      ${tachyons}

      /* FONTFACE */
      ${fontFace}

      html {
        height: 100%;
        font-size: ${theme.layout.pxSize}px;
      }

      body {
        color: ${theme.colors.black};
        font-family: ${theme.fonts.fontNormal};
        font-weight: normal;
        min-height: 100%;
        -webkit-font-smoothing: antialiased;
        -moz-osx-font-smoothing: grayscale;
        text-rendering: optimizeLegibility;
      }

      /* global link style */
      a {
        text-decoration: none;
        color: ${theme.colors.lightBlue};
      }

      h1,
      h2,
      h3,
      h4,
      h5,
      h6 {
        font-family: ${theme.fonts.fontBold};
        font-weight: normal;
        letter-spacing: ${theme.typography.headlineLetterSpacing};
        margin-bottom: 0.55rem;
        margin-top: 0.35rem;
      }

      /* 
        All styles below unused or used in M1 checkout.
        [WWW-10218] Delete all styles below after checkout removal 
      */
      .app {
        min-height: 100%;
      }

      .trade-gothic-regular {
        font-family: ${theme.fonts.fontNormal};
      }

      .trade-gothic-semi {
        font-family: ${theme.fonts.fontSemi};
      }

      .trade-gothic-bold {
        font-family: ${theme.fonts.fontBold};
      }

      .headlineSpacing {
        letter-spacing: ${theme.typography.headlineLetterSpacing};
      }

      .delicateShadow {
        box-shadow: 0 1px 3px 0 #cfdde6;
      }

      .noFlexShrink {
        flex-shrink: 0;
      }

      .noOutline {
        outline-style: none;
      }

      /* ROUTE TRANSITION */
      ${routeTransition}
    `}
  />
);

export default withTheme(GlobalBaseStyles);
